import ContentHome from "../Components/Home/ContentHome";
import { Navigate } from "react-router-dom";
import { useAuth } from "../hooks/useAuth";

function Home() {
    const { user } = useAuth();

    if (user) {
        return <Navigate to="/inicio"/>;
    }
    return(
        <>
            <ContentHome/>            
        </>
    );
}

export default Home;